<template>
    <nav class="main-header navbar navbar-expand navbar-white navbar-light" :class="warningBanner">
        <ul class="navbar-nav">
            <li class="nav-item">
                <a class="nav-link" data-widget="pushmenu">
                    <i class="fa fa-bars"></i>
                </a>
            </li>
        </ul>


        <ul class="navbar-nav ml-auto" v-if="warningBanner">
            <li class="nav-item">
                <span>
                    <b class="banner-text">TEST ENVIRONMENT</b>
                </span>
            </li>
        </ul>


        <ul class="navbar-nav ml-auto">
            <li class="nav-item d-none d-sm-inline-block">
                <a href="#" class="nav-link" @click.prevent="logout">
                    <i class="fas fa-sign-out-alt"></i>
                    {{$t('button.logout')}}
                </a>
            </li>
        </ul>
    </nav>
</template>


<script>
    export default {
        props: {warningBanner:String},
        methods: {
            logout() {
                localStorage.removeItem('token');
                this.$router.push("/login");
            }
        }
    }

</script>
<style scoped>
.warningBG{
    background-color:#fad201 !important;
}
.banner-text{
    font-size: 18px;
}
</style>

